import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge has to know the Lumen theme names (src/styles/lumen-theme.css). Unknown `text-13`
// would otherwise read as a colour and knock out `text-fg`, and `rounded-card` would not replace
// `rounded-control`. (tailwind-merge 3 reads any unknown `text-*` as a colour, so the colours are
// listed to keep that explicit, not because a colour would merge wrongly without them.)
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'canvas',
        'raised',
        'surface',
        'surface-2',
        'tint',
        'line',
        'line-strong',
        'line-control',
        'fg',
        'fg-2',
        'fg-muted',
        'label',
        'ok',
        'warn',
        'err',
        'ai',
        'on-err',
        'scrim',
        'info-ink',
        'ok-ink',
        'warn-ink',
        'err-ink',
        'ai-ink',
        'series-1',
        'series-2',
        'series-3',
        'series-4',
        'series-5',
        'series-6',
        'series-7',
        'series-8',
        'series-other',
      ],
      radius: ['tag', 'control', 'card', 'panel'],
      text: ['13'],
      font: ['ui'],
      shadow: ['overlay', 'btn', 'btn-hover'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
